<template>
  <div class="app-container">
    <div class="cost-breakdown-body">
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot" style="padding-bottom: 10px;">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px" size="mini">
          <el-form-item label="客户名称:">
             <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,index) in keHuOptions"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]" btnCode="003P01hB001">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]" btnCode="003P01hB002">重置</el-button>
            <el-button type="primary" size="mini" @click="daoru" v-if="btnFlg[2]" btnCode="003P01hB003">导入</el-button>
            <el-button type="primary" size="mini" @click="tianjia" v-if="btnFlg[3]" btnCode="003P01hB004">新增</el-button>
            <el-button type="primary" size="mini" @click="xiugai" v-if="btnFlg[4]" btnCode="003P01hB005">修改</el-button>
            <el-button type="primary" size="mini" @click="shanchu" v-if="btnFlg[5]" btnCode="003P01hB006">删除</el-button>
            <el-button type="primary" size="mini" @click="xiazai" v-if="btnFlg[6]" btnCode="003P01hB007">下载模板</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table
          height="100%"
          size="mini"
          border
          center
          bordersize="mini"
          ref="tabref1"
          :data="tableData"
          style="width: 100%"
          class="tableComent"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          highlight-current-row
          @row-click="dianjixuanzhong"
      >
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeModeTypeName" label="结算方式" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" :formatter="dateTimeFormat"></el-table-column>
      </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
    <!-- 新增或修改 -->
    <div>
      <el-dialog
        title="结算设置"
        :visible.sync="XZvisible"
        :close-on-click-modal="false"
        @close="XZvisible=false"
        width="40%"
        center
      >
        <!--form表单-->
        <el-form
          :model="XZFormData"
          ref="XZFormData"
          label-width="150px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
          :rules="Rules"
        >
          <el-form-item prop="customerTaxId" label="结算客户：">
            <el-select v-model="XZFormData.customerTaxId" size="mini" placeholder="请选择" filterable clearable :disabled="disKH">
              <el-option
                v-for="(item,index) in keHuOptions"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="feeModeType" label="结算设置：">
            <el-select v-model="XZFormData.feeModeType" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,id) in jsData"
                :key="id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="width:200px;margin:15px auto;">
          <el-button @click="XZvisible = false">取 消</el-button>
          <el-button type="primary" @click="xzQD()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import {
  getFeeModeList, // 查询
  revokeOrDelFeeMode, // 修改删除
  addFeeMode, // 添加
  importFeeMode, // 导入
  getRelationCustomer
} from '@/api/wms-stock'
import importC from '@/components/import.vue'
import { dateTimeFormat } from '@/utils/util'
export default {
  components: {
    importC
  },
  name: 'account',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      formData: {
        customerTaxId: ''
      },
      keHuOptions: [],
      // 分页
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      // 表格
      tableData: [],
      h: '500px',
      xuanzhongArr: [],
      // 按钮
      btnFlg: [],
      btnIdArr: ['003P01hB001', '003P01hB002', '003P01hB003', '003P01hB004', '003P01hB005', '003P01hB006', '003P01hB007'],
      // 导入
      daoruMark: false,
      // 新增修改
      Rules: {
        customerTaxId: [
          { required: true, message: '请选择结算客户', trigger: 'change' }
        ],
        feeModeType: [
          { required: true, message: '请选择结算客户', trigger: 'change' }
        ]
      },
      XZvisible: false,
      XZFormData: {
        customerTaxId: '',
        feeModeType: ''
      },
      addLoad: false,
      jsData: [
        {
          id: '1',
          name: '现结'
        },
        {
          id: '2',
          name: '月结'
        }
      ],
      disKH: false,
      // 导入
      importDialog: false,
      flag: 0
    }
  },
  methods: {
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E5%AE%A2%E6%88%B7%E7%BB%93%E7%AE%97%E6%96%B9%E5%BC%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      )
    },
    chaxun () {
      getFeeModeList(
        {
          ...this.formData,
          ...this.pageInfo
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.xuanzhongArr = []
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData = {
        customerTaxId: ''
      }
      this.pageInfo = {
        pageNo: 1,
        pageSize: 20
      }
      this.chaxun()
    },
    // 点击导入
    daoru () {
      this.importDialog = true
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      importFeeMode(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.$message({
          showClose: false,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {
            loading.close()
          }
        })
        this.chaxun()
      }).catch(error => {
        this.$message({
          showClose: false,
          message: error.message,
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    tianjia () {
      this.flag = 0
      this.addLoad = false
      this.XZvisible = true
      if (this.$refs.XZFormData !== undefined) {
        this.$refs.XZFormData.resetFields()
      }
    },
    xzQD () {
      // this.addLoad = true
      this.$refs.XZFormData.validate((valid) => {
        if (valid) {
          this.addLoad = true

          let customerName = this.keHuOptions.filter(item => item.taxpayerNumber == this.XZFormData.customerTaxId)[0].custerName
          let feeModeTypeName = this.jsData.filter(item => item.id == this.XZFormData.feeModeType)[0].name
          if (this.flag == 0) {
            addFeeMode(
              {
                ...this.XZFormData,
                customerName: customerName,
                feeModeTypeName: feeModeTypeName
              }
            )
              .then(res => {
                console.log(res)
                this.XZvisible = false
                this.chaxun()
              })
              .catch(error => {
                DonMessage.error(error.message)
                this.addLoad = false
              })
          } else {
            revokeOrDelFeeMode(
              {
                feeModeId: this.xuanzhongArr.feeModeId,
                feeModeType: this.XZFormData.feeModeType,
                feeModeTypeName: feeModeTypeName
              }
            )
              .then(res => {
                console.log(res)
                this.XZvisible = false
                this.chaxun()
              })
              .catch(error => {
                DonMessage.error(error.message)
                this.addLoad = false
              })
          }
        } else {
          this.addLoad = false
        }
      })
    },
    xiugai () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请先选中一条数据')
      } else {
        if (this.$refs.XZFormData !== undefined) {
          this.$refs.XZFormData.resetFields()
        }
        this.disKH = true
        this.addLoad = false
        this.XZFormData.customerTaxId = this.xuanzhongArr.customerTaxId
        this.XZFormData.feeModeType = this.xuanzhongArr.feeModeType
        this.XZvisible = true
        this.flag = 1
      }
    },
    shanchu () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请先选中一条数据')
      } else {
        this.$confirm('删除后数据不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          console.log(res)
          revokeOrDelFeeMode(
            {
              feeModeId: this.xuanzhongArr.feeModeId,
              delFlag: 1
            }
          )
            .then(res => {
              console.log(res)
              this.chaxun()
            })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = row
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 获取所属客户数据
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    }
  },
  created () {
    this.chaxun()
    this.btnFlg = getBtn(this.btnIdArr, '/account')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
    this.getRelationCustomer()
  }
}
</script>

<style lang="less" scoped>
</style>
